import {
    LENGTH_LIST_REQUEST,
    LENGTH_LIST_SUCCESS,
    LENGTH_LIST_FAIL
} from "../constants/application";

const initialState = {
  list: [],
  error: null,
  loading: false
};

export default function lengthReducer(state = initialState, action) {
  switch (action.type) {
    case LENGTH_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case LENGTH_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload,
        error: null
      };
    case LENGTH_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
}
